<template>
    <div class="main-content">
        <div class="mc-back" @click="goBack">
            <div class="flex jc-sb mb-10">
                <el-button size="small" icon="el-icon-arrow-left">返回</el-button>
            </div>
        </div>
        <div class="box box-align-center box-pack-center whiteBg relative main-step">
            <div class="box box-align-center ms-one">
                <div class="box box-align-center box-pack-center mso-circle mso-circle-on">1</div>
                <div class="mso-txt mso-txt-on">选择试卷</div>
            </div>
            <div class="ms-line" :class="currentStep == 2 ? 'ms-line-on' : ''"></div>
            <div class="box box-align-center ms-one">
                <div class="box box-align-center box-pack-center mso-circle"
                    :class="currentStep == 2 ? 'mso-circle-on' : ''">2</div>
                <div class="mso-txt" :class="currentStep == 2 ? 'mso-txt-on' : ''">发布{{ ruleForm.type == 1 ? '练习' : '考试'
                }}
                </div>
            </div>
            <div class="abs-align-center ms-btn" @click="nextStep" v-if="currentStep == 1">
                <el-button type="primary">配置{{ ruleForm.type == 1 ? '练习' : '考试' }}信息</el-button>
            </div>
        </div>
        <template v-if="currentStep == 1">
            <div class="main-title">请选择一张试卷</div>
            <div class="whiteBg main-search">
                <el-row>
                    <el-col :span="5">
                        <div class="box box-align-center mt-input">
                            <div class="mti-txt">试卷名称：</div>
                            <el-input v-model="artName" placeholder="请输入试卷名称" style="width: 150px;"
                                clearable></el-input>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="box box-align-center mt-input">
                            <div class="mti-txt">试卷分类：</div>
                            <el-cascader v-model="categoryId" :options="sortList" style="width: 150px;"
                                clearable></el-cascader>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <div class="box box-align-center mt-input">
                            <div class="mti-txt">最后更新时间：</div>
                            <el-date-picker v-model="updateTime" placeholder="请选择" type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"></el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="2" :offset="2">
                        <div class="box box-align-center box-pack-end mt-btns">
                            <el-button type="primary" icon="el-icon-search" @click="getList()">查询</el-button>
                            <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="whiteBg main-table">
                <dy-table :columns="columns" :table-data="tableData" ref="tableRef" v-loading="tableLoading"
                    :total="total" :page-num="currentPage" :page-size="pageSize" @current-change="onCurrentChange"
                    @selection-change="onSelectionChange" element-loading-text="加载中"></dy-table>
            </div>
        </template>
        <template v-else>
            <template v-if="ruleForm.type == 1">
                <div class="whiteBg main-form">
                    <el-form :model="ruleForm" :rules="rules" label-width="110px" label-position="right" ref="ruleForm"
                        style="margin: 0 auto;width: 400px;">
                        <el-form-item label="练习名称：" prop="name">
                            <el-input v-model="ruleForm.name" style="width: 210px;" placeholder="请输入练习名称"></el-input>
                        </el-form-item>
                        <el-form-item label="练习分类：">
                            <el-select v-model="ruleForm.categoryId" style="width: 210px;" placeholder="请选择练习分类">
                                <el-option v-for="item in sortList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input v-model="ruleForm.description" style="width: 210px;" placeholder="请输入备注"
                                type="textarea"></el-input>
                        </el-form-item>
                        <div class="box box-align-center box-pack-end mt-btns"
                            style="margin-top: 12px; margin-right: 30px">
                            <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
                            <el-button type="danger" plain @click="beforeStep">取消</el-button>
                        </div>
                    </el-form>
                </div>
            </template>
            <template v-else>
                <div class="whiteBg main-form">
                    <el-form :model="ruleForm" :rules="rules" label-width="110px" label-position="right" ref="ruleForm"
                        style="margin: 0 auto;width: 750px;">
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="考试名称：" prop="name">
                                    <el-input v-model="ruleForm.name" style="width: 200px;"
                                        placeholder="请输入考试名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11" :offset="2">
                                <el-form-item label="考试分类：">
                                    <el-select v-model="ruleForm.categoryId" style="width: 200px;" placeholder="请选择分类">
                                        <el-option v-for="item in sortList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="考试开始时间：">
                                    <el-date-picker v-model="ruleForm.startTime" prefix-icon="el-icon-time"
                                        type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11" :offset="2">
                                <el-form-item label="考试结束时间：">
                                    <el-date-picker v-model="ruleForm.endTime" prefix-icon="el-icon-time"
                                        type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="及格分数：">
                                    <el-input v-model="ruleForm.score" style="width: 210px;"
                                        placeholder="请输入及格分数"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11" :offset="2">
                                <el-form-item label="答题总时长：">
                                    <el-input v-model="ruleForm.answerTime" style="width: 210px;"
                                        placeholder="请输入答题总时长"></el-input>
                                    <span style="color: #666;margin-left: 8px;">分钟</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="备注：">
                            <el-input v-model="ruleForm.description" style="width: 210px;" placeholder="请输入备注"
                                type="textarea"></el-input>
                        </el-form-item>
                        <div class="box box-align-center box-pack-end mt-btns"
                            style="margin-top: 12px; margin-right: 30px">
                            <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
                            <el-button type="danger" plain @click="beforeStep">取消</el-button>
                        </div>
                    </el-form>
                </div>
            </template>
        </template>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import { paperList, zgsourceAllCategory, examSave, examGetInfo } from '@/api/index2';
import { formatDate, uniqueBy, subtractArrays } from '@/utils/utils';
import { encrypt } from '@/api/common_encrypt';

var that = null;
export default {
    components: {
        DyTable
    },
    data() {
        const { editArticle } = this;
        return {
            artName: '',
            tableLoading: false,
            dialogTitle: '创建试卷',
            columns: [
                {
                    type: "selection",
                    width: "55"
                },
                {
                    key: 'paperName',
                    title: '试卷名称',
                },
                {
                    key: 'categoryName',
                    title: '试卷分类',
                },
                {
                    key: 'creatorName',
                    title: '试卷创建人',
                },
                {
                    key: 'createTime',
                    title: '试卷创建时间',
                },
                {
                    key: '',
                    title: '操作',
                    width: 100,
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-link type='primary' onClick={() => editArticle(row)}>
                                    预览
                                </el-link>
                            </div>
                        )
                    },
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            ruleForm: {
                name: '',
                type: 1,//1:练习  2：考试
                categoryId: '',
                paperName: '',
                paperId: 0,
                startTime: '',
                endTime: '',
                score: 0,
                answerTime: '',
                description: '',
            },
            rules: {
                name: [{ required: true, message: '请输入练习名称', trigger: 'blur' }],
            },
            addVisible: false,
            categoryId: '',
            updateTime: '',
            sortList: [],
            currentStep: 1,
            channelType: [],

            resultList: [],//选择后的数据
            delData: [],//删除的数据id
            isChange: false,
        };
    },
    mounted() {
        that = this;
        that.getList();
        that.getCategory();
        that.ruleForm.type = this.$route.query.type;
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
            };
        },
    },
    methods: {
        goBack() {
            that.$router.back();
        },
        beforeStep() {
            that.currentStep = 1;
            that.getList();
        },
        // 选择后数据处理
        onSelectionChange(val) {
            console.log(val, 'onSelectionChange');
            if (that.isChange) {
                return;
            }
            if (val.length == that.tableData.length) {
                // 保证只有一个被选中
                const lastSelected = this.resultList.length > 0 ? this.resultList[0] : null;
                this.$refs.tableRef.$refs.ElTable.clearSelection();
                if (lastSelected) {
                    this.$refs.tableRef.$refs.ElTable.toggleRowSelection(lastSelected, true);
                }
                that.$message.warning('只能选一个试卷');
                return;
            }
            if (val.length > 1) {
                this.resultList = [];
                // 保证只有一个被选中
                const lastSelected = val[val.length - 1];
                this.$refs.tableRef.$refs.ElTable.clearSelection();
                this.$refs.tableRef.$refs.ElTable.toggleRowSelection(lastSelected, true);
                this.resultList = [lastSelected];
            } else {
                this.resultList = val;
            }
        },
        //预览
        editArticle(p) {
            let param = {
                paper: p
            }
            that.$router.push({
                path: '/paperPreview',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },
        // 配置试卷信息
        nextStep() {
            if (that.resultList.length == 0) {
                that.$message.warning('请先选择试卷');
                return;
            }
            that.currentStep = 2;
        },
        //重置列表
        resetList() {
            that.currentPage = 1;
            that.artName = '';
            that.categoryId = '';
            that.currentDT = '';
            that.getList();
        },
        onCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        setPage() {
            // 重新设置选中状态
            this.$nextTick(() => {
                let selList = [];
                console.log('当前选择数据', this.resultList);
                this.$refs.tableRef.$refs.ElTable.clearSelection();
                if (this.resultList.length > 0) {
                    this.resultList.forEach((item) => {
                        const row = this.tableData.find((row) => row.id === item.id);
                        if (row) {
                            selList.push(row);
                            this.$refs.tableRef.$refs.ElTable.toggleRowSelection(row, true);
                        }
                    });
                    this.delData = subtractArrays(this.tableData, selList, 'id');
                }
            })
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
        // 提交表单
        submitForm(formName) {
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    var info = that.ruleForm;
                    info.paperId = that.resultList[0].id - 0;
                    info.paperName = that.resultList[0].paperName;
                    console.log(info, '我是表单');
                    examSave(info).then((res) => {
                        if (res.result == 1) {
                            console.log(res);
                            that.$message({
                                showClose: true,
                                message: '保存成功',
                                type: 'success',
                            });
                            that.$nextTick(() => {
                                that.$router.push({
                                    path: info.type == 1 ? '/practiceManagement' : 'examManage',
                                });
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error',
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //获取详情
        examGetInfo(id) {
            let param = {
                id,
            }
            examGetInfo(param).then((res) => {
                if (res.result == 1) {
                    console.log('详情', res);
                    that.ruleForm = res.data;
                    that.$refs.tableRef.$refs.ElTable.clearSelection();
                    const row = that.tableData.find((row) => row.id == res.data.paperId);
                    if (row) {
                        that.$refs.tableRef.$refs.ElTable.toggleRowSelection(row, true);
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },
        getCategory() {
            let param = {
                type: 3,
            }
            zgsourceAllCategory(param).then((res) => {
                if (res.result == 1) {
                    console.log('试卷分类', res);
                    that.sortList = that.listFor(res.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },
        getList() {
            that.tableLoading = true;
            let info = {
                name: that.artName,
                categoryId: that.categoryId || '',
                startTime: that.updateTime ? that.updateTime[0] : null,
                endTime: that.updateTime ? that.updateTime[1] : null,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true,
            };
            console.log(info);
            paperList(info).then((res) => {
                if (res.result == 1) {
                    console.log('试卷列表', res);
                    let ress = res.data;
                    that.total = ress.total;
                    that.currentPage = ress.pageNum;
                    that.tableData = ress.list.map((item) => {
                        return {
                            ...item,
                            createTime: item.createTime ? formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss') : '',
                        };
                    });
                    that.tableLoading = false;
                    if (that.$route.query.id) {//获取详情
                        that.examGetInfo(that.$route.query.id);
                    }
                    that.setPage();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-form-item__content {
    margin-left: 0 !important;
    margin-bottom: 48px;
}

.mti-txt {
    white-space: nowrap;
    margin-left: 10px;
}

.whiteBg {
    background-color: #fff;
}

div {
    box-sizing: border-box;
}

.relative {
    position: relative;
}

.abs-align-center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.main-content {
    padding: 16px;
    background-color: rgb(236, 239, 243);

    .main-step {
        height: 60px;

        .ms-one {
            color: #ccc;

            .mso-circle {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                border: 2px solid #ccc;
            }

            .mso-circle-on {
                color: #fff;
                background-color: #46A3FF;
                border: 2px solid #46A3FF;
            }

            .mso-txt {
                margin-left: 8px;
            }

            .mso-txt-on {
                color: #46A3FF;
            }
        }

        .ms-line {
            width: 250px;
            margin: 0 12px;
            height: 1px;
            background-color: #ccc;
        }

        .ms-line-on {
            background-color: #46A3FF;
        }

        .ms-btn {
            right: 30px;
        }
    }

    .main-title {
        font-size: 18px;
        margin: 24px 0 0;
    }

    .main-search {
        margin: 5px 0 10px;
        padding: 16px;
    }

    .main-form {
        margin: 16px auto 0;
        padding-top: 24px;
        padding-bottom: 24px;
    }
}
</style>